import getLangSync from "./components/LangSync.js"
import getDuplicateProduct from "./components/DuplicateProduct";

const ProductLangSync = getLangSync({
  langs: ["it", "en"],
  baseFields: ["name", "body", "sku", "maxPressureBar", "maxPressurePsi", "maxFlowLph", "powerKw", "rpm"],
  asides: true,
  relations: [
    {
      field: "categories",
      namespace: "catalog",
      model: "categories",
      handlers: ["permalink", "lang"]
    },
    {
      field: "accessories",
      namespace: "catalog",
      model: "products",
      handlers: ["permalink", "lang"]
    },
    {
      field: "optAccessories",
      namespace: "catalog",
      model: "products",
      handlers: ["permalink", "lang"]
    },
    {
      field: "applications",
      namespace: "catalog",
      model: "applications",
      handlers: ["permalink", "lang"]
    },
    {
      field: "attachments",
      namespace: "attachments",
      model: "attachments",
      handlers: ["permalink", "lang"]
    }
  ]
})

const DownloadsLangSync = getLangSync({
  langs: ["it", "en"],
  baseFields: ["title"],
  asides: true,
  relations: [
    {
      field: "categories",
      namespace: "contents",
      model: "categories",
      handlers: ["permalink", "lang"]
    }
  ]
})

const NewsLangSync = getLangSync({
  langs: ["it", "en"],
  baseFields: ["title", "body", "layoutId"],
  asides: true,
  relations: [
    {
      field: "categories",
      namespace: "contents",
      model: "categories",
      handlers: ["permalink", "lang"]
    },
    {
      field: "attachments",
      namespace: "attachments",
      model: "attachments",
      handlers: ["permalink", "lang"]
    }
  ]
})

const HelpLangSync = getLangSync({
  langs: ["it", "en"],
  baseFields: ["title", "body"],
  asides: true,
  relations: []
})

const DuplicateProduct = getDuplicateProduct({
	langs: ["it", "en"],
	baseFields: ["name", "body", "sku", "maxPressureBar", "maxPressurePsi", "maxFlowLph", "powerKw", "rpm"],
	asides: true,
	relations: [
		{
			field: "categories",
			namespace: "catalog",
			model: "categories",
			handlers: ["permalink", "lang"]
		},
		{
			field: "accessories",
			namespace: "catalog",
			model: "products",
			handlers: ["permalink", "lang"]
		},
		{
			field: "optAccessories",
			namespace: "catalog",
			model: "products",
			handlers: ["permalink", "lang"]
		},
		{
			field: "applications",
			namespace: "catalog",
			model: "applications",
			handlers: ["permalink", "lang"]
		},
		{
			field: "attachments",
			namespace: "attachments",
			model: "attachments",
			handlers: ["permalink", "lang"]
		}
	]
})

export default {
  components: { ProductLangSync, DownloadsLangSync, NewsLangSync, HelpLangSync, DuplicateProduct }
}



// WEBPACK FOOTER //
// src/custom/index.js